import { render, staticRenderFns } from "./RoundsReviewPage.vue?vue&type=template&id=1e77b7c2"
import script from "./RoundsReviewPage.vue?vue&type=script&lang=js"
export * from "./RoundsReviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports